module.exports = __webpack_public_path__ + "img/menu-icon.1ab299c8.svg";